import { jsx as _jsx } from "react/jsx-runtime";
import { CatModal } from '@blocks-react/components/Modal';
export const MyEquipmentView = ({ children, onBlModalClose, isActive, size, classname }) => {
    return (_jsx(CatModal, { onBlModalClose: onBlModalClose, isActive: isActive, size: size, className: classname, children: children }));
};
